export default __webpack_public_path__ + "static/media/ktb.0ce277c1.svg";